module.exports = __webpack_public_path__ + "static/img/1_1_2.27d609b8.jpg";